var map = {
	"./3d-agency picture.png": 8581,
	"./Communication-aggregator -system.png": 8514,
	"./Customer-Support-Ticketing-Knowledge-Base-System.png": 388,
	"./Droiod-slam-jetson-AGX.jpg": 947,
	"./Information Security Management System.jpeg": 5614,
	"./Insurance-Claim-Processing-Automation.jpg": 1191,
	"./Real-Time Data Pipeline Using-Kafka.png": 5538,
	"./Secret-santa.jpeg": 9976,
	"./Smart-coach.png": 6723,
	"./Splunk-dashboard.png": 7588,
	"./Thumbs.db": 6635,
	"./appointment-scheduling-agent.png": 3015,
	"./gaming-leaderboard.jpg": 4632,
	"./garbage-classification.png": 9502,
	"./home.png": 5677,
	"./inicio.png": 7109,
	"./log_stream_distributed_system_image.jpeg": 1916,
	"./network-diagnostics-troubleshooting-toolkit.jpg": 2480,
	"./portfolio.png": 1022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;